// extracted by mini-css-extract-plugin
export default {"root":"PlasmicBranding_root__LOOaW","rootselected":"PlasmicBranding_rootselected__+Vlie","text":"PlasmicBranding_text__ev850"};